<template>
  <component
    class="btn flex items-center justify-center rounded-r1 disabled:cursor-not-allowed"
    :is="link && !link.download ? nuxtLink : 'button'"
    :class="[
      c_style?.name ?? 'main',
      c_style?.type ?? 'primary',
      c_style?.style ?? 'A',
      {
        '!py-0': loading,
      },
    ]"
    :type
    :disabled
    :to="link ? link.path : undefined"
    :external="link?.external"
    :target="link?.external ? '_blank' : undefined"
    @click="handleClick"
  >
    <template v-if="!loading">
      <CommonUIcons
        :class="[
          c_style?.type === 'ghost'
            ? 'h-icon_size_3 w-icon_size_3'
            : 'h-icon_size_4 w-icon_size_4',
        ]"
        :name="prefix_icon"
      />

      <p class="btn-label text-center font-secondary">
        {{ label }}
      </p>

      <CommonUIcons
        :class="
          c_style?.type === 'ghost'
            ? 'h-icon_size_3 w-icon_size_3'
            : 'h-icon_size_4 w-icon_size_4'
        "
        :name="suffix_icon"
      />
    </template>

    <template v-else>
      <CommonUIcons
        v-if="
          c_style?.type === 'tertiary' ||
          c_style?.type === 'text' ||
          c_style?.type === 'ghost'
        "
        name="ic-spinner-loading"
        prefix="a"
        class="self-center"
        style="
          height: calc(var(--icon_size_6));
          width: calc(var(--icon_size_6));
        "
      />
      <CommonUIcons
        v-else
        name="ic-loading"
        prefix="a"
        style="
          height: calc(var(--icon_size_4) + 28px);
          width: calc(var(--icon_size_4) + 28px);
        "
      />
    </template>
  </component>
</template>

<script setup lang="ts">
import type { ButtonProps } from "~/types/schemas/common/Atom/button";
import { downloadFileInBrowser } from "~/utils/common/file";

const props = withDefaults(defineProps<ButtonProps>(), {
  type: "button",
});

const nuxtLink = resolveComponent("NuxtLink");

const handleClick = async () => {
  if (props.link?.path && props.link?.download) {
    await downloadFileInBrowser(
      props.link.path.toString(),
      props.link.downloadFileName,
    );
  }
};
</script>

<style scoped>
@import "~/assets/css/common/atom/buttons.css";

.btn {
  line-height: var(--icon_size_4);

  .ghost {
    line-height: var(--icon_size_3);
  }
}
</style>
